<template>
  <div class="card" @click="$emit('click')">
    <div class="header">
      <div class="title">
        <p class="body-menu caps align-left">{{card.label}}</p>
        <p class="name align-left" v-html="card.title"></p>
      </div>
      <div class="score">
        <div>
          <p class="val align-center">SCORE</p>
          <p class="caption align-center">{{score}}/{{card.questionCount}}</p>
        </div>
        <img v-if="score !== '-' && (score / card.questionCount) < 0.7" src="@/assets/lessons/card/score-medium.svg" />
        <img v-if="score !== '-' && (score / card.questionCount) >= 0.7" src="@/assets/lessons/card/score-good.svg" />
        <img v-if="score === '-'" src="@/assets/lessons/card/score-null.svg" />
      </div>
    </div>
    <div class="body">
      <div class="description">
        <span class="caption align-left"> 
          <strong>What you will learn</strong><br>
          <span v-html="card.cardDescription" class="card-description"></span>
        </span>
      </div>
      <div class="footer">
        <IconText class="quizz" icon="quizz" :text="card.quizCount" />
        <IconText class="time" icon="time" :text="`${card.estimateOfCompletionTime}`"/>
      </div>
    </div>
  </div>
</template>


<script>
  import {mapGetters} from 'vuex'
  import IconText from "@/components/lessons/card/IconText"
  export default {
    name: 'Card',
    components: {
      IconText,
    },
    data () {
      return {
        score: ''
      }
    },
    computed: {
      ...mapGetters( {
        scores: 'user/moduleCompletion'
      })
    },
    props: {
      card: {
        type: Object,
        default: function () {
          return {}
        }
      }
    },
    mounted () {
      this.getUserScore(this.card.id)
    },
    methods: {
      getUserScore(module_id) {
        var scoreTmp = this.scores && this.scores.filter(s => s.idModule === module_id)[0]
        if (scoreTmp) {
          this.score =  scoreTmp.latestScore
        } else {
          this.score =  '-'
        }
      }
    },
    watch: {
      scores() {
        this.getUserScore(this.card.id)
      }
    }
  }
</script>

<style lang="scss">
@import "@/styles";

  .card {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    background-color: white;
    min-width: 320px;
    width: 100%;
    max-width: 366px;
    height: 100%;
    box-sizing: border-box;
    color: $primary;
    border: 1px solid #E4E7ED;

    &:hover {
      cursor: pointer;
    }

    @media (max-width: 320px) {
      min-width: 280px;
    }

    .header {
      display: flex;
      color: $primary;
      flex-direction: row;
      padding: 18px;
      padding-bottom: 0;
      border-bottom: none;

      .title {
        flex: 3;

        p {
          margin-bottom: 0;
          margin-top: 0;
          &.name {
            font-size: 18px;
            font-weight: 500;
          }
        }

        .name {
          i {
            color: #4632FF;
          }
        }
      }
      .score {
        flex: 1;
        margin-right: 0;
        margin-left: auto;
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: center;
        color: black;
        p {
          margin: 0;
        }
        .val {
          font-weight: 700;
          font-size: 8px;
        }
        img {
          margin-left: 12px;
        }
      }
    }
    
    .body {
      display: flex;
      flex-direction: column;
      height: 100%;
      margin-top: auto;
      padding: 18px;
      padding-top: 0;

      .description {
        height: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        margin-top: 12px;
        flex-grow: 1;
        margin-bottom: auto;
        margin-bottom: 10px;
        color: $text;
      }

      .footer {
        display: flex;
        flex-direction: row;
        margin-top: auto;
        margin-bottom: 0;
        align-items: center;
        height: 30px;
      }

      .card-description i {
        color: #4632FF;
      }
    }
  }
</style>